var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',{attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.goToNext()}}},[_c('div',[_vm._v(_vm._s(_vm.model.controlCardNumber))]),_c('div',[_vm._v(_vm._s(_vm.model.qtyCase))])])}
var staticRenderFns = []

export { render, staticRenderFns }